import getGenderByModelName from "src/helpers/text/getGenderByModelName"

export default function(modelName) {
  switch (getGenderByModelName(modelName)) {
    case `masculine`:
      return ``
    case `neuter`:
      return `о`
    case `feminine`:
      return `а`
    default:
      return null
  }
}
